import React from 'react';
import {Dialog, List} from 'material-ui';
import {DialogTitle} from 'material-ui';
import {Button} from 'material-ui';
import {DialogContent} from 'material-ui';
import {DialogContentText} from 'material-ui';

function WipeSlateCleanDialog({isOpen, onAccept, onDeny, t, onClose}) {
	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
		>
			<DialogTitle id='alert-dialog-title'>
				{t('common:appName')}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id='alert-dialog-description'>
					{t('workout:warnBeforeWiping')}
				</DialogContentText>

				<List>
					<Button
						fullWidth={true}
						size='large'
						onClick={onAccept}
						color='primary'
					>
						{t('workout:doWipeSlateClean')}
					</Button>
					<Button
						fullWidth={true}
						size='large'
						onClick={onDeny}
						color='primary'
						autoFocus
					>
						{t('workout:dontWipeSlateClean')}
					</Button>
				</List>
			</DialogContent>
		</Dialog>
	);
}
export default WipeSlateCleanDialog;



// WEBPACK FOOTER //
// ./src/overview/WipeSlateCleanDialog.js